var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      _a$color = a.color,
      d = _a$color === void 0 ? "#809cc8" : _a$color,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    }, d ? {
      fill: d
    } : {})
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17v33.574c17.301-7.203 40.414-14.441 69.504-21.75C88.145 24.152 106.16 20.223 123.559 17zm128 7.16c-16.867 2.504-31.996 5.457-45.309 8.789-15.242 3.828-27.512 7.699-36.793 11.645-9.293 3.875-13.609 7.008-13.004 9.426.547 2.129 4.438 3.098 11.691 2.898 3.73-.07 9.777-.48 18.168-1.223l32.488-3.219c13.145-1.355 24.031-2.273 32.758-2.809zM90.527 66.75c-3.73.047-8.871.332-15.449.816-6.602.492-14.77 1.207-24.559 2.219L12.641 73.5c-4.816.406-8.996.66-12.641.863v27.23c19.938-2.914 37.973-6.391 54.055-10.422 15.797-3.957 27.941-7.82 36.473-11.555 8.547-3.734 12.535-6.902 11.871-9.469-.555-2.215-4.559-3.34-11.871-3.398zM128 76.309c-17.52 6.863-39.266 13.598-65.246 20.121C38.566 102.492 17.672 106.832 0 109.523v.227h128zM5.348 82.02c.063-.008.113 0 .18 0 .332.012.684.113.906.363a1.25 1.25 0 01-1.133 2.082c-.617-.09-1.094-.695-1.043-1.312.02-.582.512-1.062 1.09-1.133zm4.531 0c.289.012.555.07.77.273a1.25 1.25 0 01.363 1.402c-.187.496-.691.863-1.227.816-.457-.02-.906-.305-1.086-.727-.25-.547-.047-1.285.5-1.586.203-.121.441-.184.68-.18zm-4.352 8.02c.539-.016 1.023.363 1.18.859.164.555-.098 1.254-.637 1.496-.539.27-1.246.102-1.586-.406-.344-.496-.297-1.242.184-1.633.234-.207.547-.324.859-.316zm4.352 0c.43-.023.809.25 1.039.59a1.23 1.23 0 01-.316 1.629c-.512.391-1.312.324-1.723-.18-.422-.504-.391-1.359.137-1.766.23-.191.563-.281.863-.273zm0 0"
  }));
};